module.exports = __webpack_public_path__ + "static/Nougat-f36ccfe664f9e58e8e1bc0de65021b19.png";